<h1 mat-dialog-title>{{ dialogTitle }}</h1>
<mat-dialog-content [formGroup]="accountFormGroup" *ngIf="accountFormGroup">
    <fieldset>
        <legend>Information</legend>
        <div fxLayout="row">
            <mat-form-field fxFill>
                <input matInput formControlName="userName" placeholder="Username" required />
                <mat-error *ngIf="accountFormGroup.controls.userName.hasError('email')"
                    >Username must be an email address</mat-error
                >
                <mat-error *ngIf="accountFormGroup.controls.userName.hasError('required')">
                    Username is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field fxFill>
                <input matInput formControlName="firstName" placeholder="Firstname" required />
                <mat-error *ngIf="accountFormGroup.controls.firstName.hasError('required')">
                    Firstname is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field fxFill>
                <input matInput formControlName="lastName" placeholder="Lastname" required />
                <mat-error *ngIf="accountFormGroup.controls.firstName.hasError('required')">
                    Lastname is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field fxFill>
                <input
                    matInput
                    formControlName="employee"
                    placeholder="Employee"
                    [matAutocomplete]="autoEmployees"
                    (ngModelChange)="employeeQuerySearch($event)"
                    required />
                <mat-error *ngIf="accountFormGroup.controls.employee.hasError('required')">
                    Employee is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="accountFormGroup.controls.employee.hasError('employeeNotInList')">
                    Employee not <strong>found</strong>
                </mat-error>
            </mat-form-field>
            <mat-autocomplete #autoEmployees="matAutocomplete">
                <mat-option *ngFor="let employee of filteredEmployees; trackBy: trackBy" [value]="employee.fullName">{{
                    employee.fullName
                }}</mat-option>
                <mat-option *ngIf="!isEmployeesFound" disabled>No matching employees found</mat-option>
            </mat-autocomplete>
        </div>
    </fieldset>

    <fieldset>
        <legend>Roles</legend>
        <div fxLayout="row" fxFlex="100">
            <mat-checkbox
                aria-label="roleRestricted"
                (change)="onCheck('RestrictedUser')"
                [checked]="checkedName === 'RestrictedUser'"
                fxFlex="45"
                formControlName="roleRestricted">
                Restricted User
            </mat-checkbox>
            <mat-checkbox
                aria-label="roleUser"
                (change)="onCheck('TimesheetUser')"
                [checked]="checkedName === 'TimesheetUser'"
                fxFlex="45"
                formControlName="roleUser">
                User
            </mat-checkbox>
        </div>
        <div fxLayout="row" fxFlex="100">
            <div fxFlex="10"></div>
            <mat-checkbox
                aria-label="roleAdmin"
                (change)="onCheck('Administrator')"
                [checked]="checkedName === 'Administrator'"
                fxFlex="45"
                formControlName="roleAdmin">
                Admin
            </mat-checkbox>
            <mat-checkbox
                aria-label="roleImport"
                (change)="onCheck('Importer')"
                [checked]="checkedName === 'Importer'"
                fxFlex="45"
                formControlName="roleImport">
                Importer
            </mat-checkbox>
        </div>
    </fieldset>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close (click)="cancelDialog()">
        <span>Cancel</span>
    </button>
    <button
        mat-flat-button
        [color]="crud !== 4 ? 'primary' : 'warn'"
        (click)="crud === 4 ? deleteAccount() : saveAccount()"
        [disabled]="accountFormGroup.invalid && crud !== 4 && crud !== 3">
        <span *ngIf="crud === 1">Create</span>
        <span *ngIf="crud === 3">Save</span>
        <span *ngIf="crud === 4 && !confirmDelete">Delete</span>
        <span *ngIf="crud === 4 && confirmDelete">Are you sure?</span>
    </button>
</mat-dialog-actions>
